import { FileResource } from '../../item/model/FileResource'
import { ViewerToolBar } from './FileViewerToolBar'
import { Divider } from '@mui/material'
import { useState } from 'react'
import './FileViewer.scss'

export const ImageViewer = (
{
    file
}:{
    file: FileResource
}) => {

    const [scale, setScale] = useState<number>(1)

    const handleZoomIn = () => {
        setScale(s => Math.min(3, +(s + 0.1).toFixed(2)))
    }

    const handleZoomOut = () => {
        setScale(s => Math.max(0.1, +(s - 0.1).toFixed(2)))
    }

    return (
        <div className="viewer-container">
            <ViewerToolBar 
                file={file} 
                handleZoomIn={handleZoomIn}
                handleZoomOut={handleZoomOut}
            />
            <Divider className="divider" />
            <div className="image-viewer">
                <img
                    src={file.uri}
                    alt={file.name || 'image'}
                    style={{
                        transform: `scale(${scale})`,
                        transformOrigin: 'center'
                    }}
                    className="image-viewer-img"
                />
            </div>
        </div>
    )
}